import get from 'lodash/get';

import { objectKeysToCamelCase } from '../helpers';

// TODO: merge this configuration with app/javascript/config.es6
// and use this object as only source of truth for configuration.
export const AppConfig = {
  // Some app settings, like max file sizes or app revision
  appSettings: objectKeysToCamelCase(get(window, '__app_settings__', {})),

  // For a film festival we need to permit larger uploads for a specific channel.
  // ^ August 31th, 2017. I can imagine we can remove that code already...
  channelSettings: objectKeysToCamelCase(get(window, 'ChannelSettings', {})),

  // Backgrounds uploaded by the user
  channelWallpapers: objectKeysToCamelCase(get(window, 'Wallpapers', [])),

  // A set of WeTransfer curated wallpapers available for users when onboarding
  curatedWallpapers: objectKeysToCamelCase(
    get(window, '__curated_wallpapers__', [])
  ),

  // Describe the runtime environment
  env: {
    development: __DEV__ === true,
    wallpaperDevelopment: __WALLPAPER_DEV_ENABLED__ === true,
  },

  // Deprecated feature flag functionality. Should be merged with launchDarkly
  featureFlags: objectKeysToCamelCase(get(window, '__feature_flags__', {})),

  // Configuration for Intercom (only on plus for teams)
  intercom: objectKeysToCamelCase(get(window, '__intercomSettings__', {})),

  // This is a global variable that should be defined by
  // loading 'advertising.js' scripts - however, if it is not
  // set this means it was blocked by ad blockers. OH MY GLOB.
  isAdvertisingEnabled: !!window['__ads_enabled__'],

  // Configuration and feature flags from LaunchDarkly
  launchDarkly: {
    clientID: get(window, '__launch_darkly__.client_id', ''),
    enabled: get(window, '__launch_darkly__.enabled', false),
    featureFlags: get(window, '__launch_darkly__.feature_flags', {}),
  },

  // Includes the list of all assets generated by Rails
  manifest: get(window, '__manifest__', {}),

  // Complete information about a transfer, available on download page
  preloadedTransfer: objectKeysToCamelCase(
    get(window, '_preloaded_transfer_', {})
  ),

  // Google Reacaptcha configuration
  recaptcha: objectKeysToCamelCase(get(window, '__recaptcha__', {})),

  // All the information related to the user: account, profile, etc
  session: objectKeysToCamelCase(get(window, '__session__', {})),

  // Configuration for Stripe
  stripe: objectKeysToCamelCase(get(window, '__stripe__', {})),

  // Configuration for TrackJS
  trackJS: objectKeysToCamelCase(get(window, '__trackjs__', {})),

  // Application translation. Huge object, be careful ;)
  translations: get(window, '_i18n_', {}),

  /**
   * Webpack exposes a global variable called __webpack_public_path__ that allows
   * to set the public path for lazy loaded scripts on the fly.
   * Be aware that if you use ES6 module imports in your entry file
   * the __webpack_public_path__ assignment will be done after the imports.
   * In such cases, you'll have to move the public path assignment
   * to its own dedicated module and then import it on top of your application.es6
   * That's why we are doing this.
   */
  webpackPublicPath: get(window, '__webpack_public_path__', '/assets/'),
};
